export default __webpack_public_path__ + "static/media/notificationBlank.bbf2dc27.svg";